import { type FC } from 'react'
import classNames from 'classnames'
import { type CustomWorkflowTriggerType } from '../../../store/customWorkflow/customWorkflows'
import { tagHueBorderClass, tagHueClass, type TagHue } from '../../../components/CustomWorkflows/workflowTags'
import { type WorkflowEnablement } from './workflowEnablement'

interface WorkflowCardFooterProps {
  triggerType: CustomWorkflowTriggerType
  enablement: WorkflowEnablement
  hasParameters: boolean
  runFrom: string | null
}

interface FooterStatus {
  label: string
  icon: string
  hue: TagHue
}

const STATUSES: Record<WorkflowEnablement, FooterStatus> = {
  required: { label: 'Required', icon: 'bi-lock-fill', hue: 'indigo' },
  organization: { label: 'Enabled for your organization', icon: 'bi-people-fill', hue: 'green' },
  enabled: { label: 'Enabled', icon: 'bi-circle-fill', hue: 'green' },
  disabled: { label: 'Not enabled', icon: 'bi-circle', hue: 'slate' },
}

export const WorkflowCardFooter: FC<WorkflowCardFooterProps> = ({ triggerType, enablement, hasParameters, runFrom }) => {
  const status = STATUSES[enablement]
  return (
    <div className='mt-auto w-100 pt-2'>
      <div className='pt-3 border-top zocks-border-color-gray-200 d-flex justify-content-between align-items-center gap-2'>
        {triggerType === 'manual' ? (
          <span className='paragraph-extra-small zocks-text-gray-600'>{runFrom === null ? 'Run manually' : `Runs from ${runFrom}`}</span>
        ) : (
          <div
            className={classNames(
              'd-inline-flex align-items-center gap-1 px-2 py-1 rounded-2 paragraph-extra-small medium border',
              tagHueClass(status.hue),
              tagHueBorderClass(status.hue),
            )}
          >
            <i className={classNames('bi', status.icon)} aria-hidden='true' />
            {status.label}
          </div>
        )}
        {hasParameters ? <span className='paragraph-extra-small medium zocks-text-primary'>Configure</span> : null}
      </div>
    </div>
  )
}
